// #2753 Quick Order: mounted once in the app shell. Listens for openQuickOrder() and shows the flow (loaded only when first asked for).
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { QUICK_ORDER_EVENT } from './quickOrderLauncher';

const QuickOrder = lazy(() => import('./QuickOrder'));

export default function QuickOrderHost() {
  const [state, setState] = useState(null); // null = closed, { initial } = open
  useEffect(() => {
    const onOpen = (e) => setState({ initial: (e && e.detail) || null, key: Date.now() });
    window.addEventListener(QUICK_ORDER_EVENT, onOpen);
    return () => window.removeEventListener(QUICK_ORDER_EVENT, onOpen);
  }, []);
  if (!state) return null;
  return (
    <Suspense fallback={null}>
      <QuickOrder key={state.key} open initial={state.initial} onClose={() => setState(null)} />
    </Suspense>
  );
}
